<template>
  <div class="project">
    <div class="view-content">
      <div class="columns is-multiline is-variable is-full">
        <div class="column is-full is-full-tablet is-full-touch timeline-and-buttons">
          <project-timeline />
          <div class="state-and-date-container">
            <div class="start-date-container">
              <div class="project-date-label">
                Project starts
              </div>
              <div class="date-picked">
                <p v-if="startDateFormatted !== ''">{{ startDateFormatted }}</p>
              </div>
              <div class="select-date-button-icon">
                <b-datepicker v-model="selectedStartDate" :mobile-native="false" append-to-body
                              position="is-bottom-left">
                  <template v-slot:trigger>
                    <b-button>
                      <fa class="calendar-icon" icon="calendar-plus"></fa>
                    </b-button>
                  </template>
                </b-datepicker>
              </div>
            </div>
            <div class="state-selector-container">
              <div class="project-state-label">
                <p>Project state</p>
              </div>
              <div class="project-state-label">
                <fa v-if="selectedState" :icon="selectedState.icon" class="state-icon"></fa>
                <p v-if="selectedState">{{ selectedState.label }}</p>
              </div>
              <div class="select-date-button-icon">
                <b-dropdown
                    v-model="selectedState"
                    append-to-body
                    aria-role="list"
                    max-height="400px"
                    position="is-bottom-left"
                    scrollable
                    type="is-primary"
                    @change="setNewState"
                >
                  <template #trigger>
                    <b-button>
                      <fa :style="{color: '#fff'}" class="state-picker-icon" icon="chevron-circle-down"
                      ></fa>
                    </b-button>
                  </template>
                  <b-dropdown-item
                      v-for="(state, index) in availableStates"
                      :key="index"
                      :value="state" aria-role="listitem">
                    <div class="media">
                      <b-icon :icon="state.icon" class="media-left" size="is-small"></b-icon>
                      <div class="media-content">
                        <h3>{{ state.label }}</h3>
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half-desktop is-full-tablet is-full-touch">
          <div :class="{short : !show.details}" class="box">
            <div class="columns">
              <div class="column is-12">
                <div class="container__sub-title is-full" @click="toggleMinimise('details')">
                  <h1 class="title has-size-4">Project Details</h1>
                  <!--                  <div class="edit">-->
                  <!--                    <fa icon="pencil" size="1x" :style="{color: '#fff'}"></fa>-->
                  <!--                  </div>-->
                  <div v-if="deviceIsMobile" class="minimise">
                    <fa :icon="show.details ? 'chevron-down' : 'chevron-right'" :style="{color: '#fff'}" size="1x"></fa>
                  </div>
                  <b-modal
                      v-model="sapAssessmentModal"
                      :destroy-on-hide="false"
                      aria-modal
                      aria-role="dialog"
                      close-button-aria-label="Close"
                      has-modal-card
                      trap-focus>
                    <section v-if="!deviceIsMobile" class="sapAssessmentModalClass">
                      <div class="sapAssessmentModalHeader">
                        <h1>Request Sent Successfully</h1>
                      </div>
                      <div class="sapAssessmentModalText">
                        <p>We have sent your request for an SAP Assessment to a member of our team and they will be in
                          touch shortly</p>
                      </div>
                      <div class="sapModalButtonDiv">
                        <b-button class="sapModalButton" @click="closeSapAssessmentModal">Close</b-button>
                      </div>
                      <modal-form @close="closeSapAssessmentModal"></modal-form>
                    </section>
                    <section v-if="deviceIsMobile" class="sapAssessmentModalClassMobile">
                      <div class="sapAssessmentModalHeader">
                        <h1>Request Sent Successfully</h1>
                      </div>
                      <div class="sapAssessmentModalText">
                        <p>We have sent your request for an SAP Assessment to a member of our team and they will be in
                          touch shortly</p>
                      </div>
                      <div class="sapModalButtonDiv">
                        <b-button class="sapModalButton" @click="closeSapAssessmentModal">Close</b-button>
                      </div>
                      <modal-form @close="closeSapAssessmentModal"></modal-form>
                    </section>
                  </b-modal>
                </div>
                <div v-if="show.details" class="content">
                  <!--                  <div v-if="deviceIsMobile" class="sapAssessmentMobile">-->
                  <!--                    <b-button class="sapAssessmentButtonMobile" @click="openSapAssessmentModal" type="is-success">-->
                  <!--                      Request SAP Assessment-->
                  <!--                    </b-button>-->
                  <!--                  </div>-->
                  <div class="box short white">
                    <div class="columns is-mobile">
                      <div class="column is-half">
                        <p class="has-text-weight-bold is-size-6">Project Ref</p>
                      </div>
                      <div class="column is-half">
                        <p class="has-text-right">{{ project.ref }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="box short white">
                    <div class="columns is-mobile">
                      <div class="column is-half">
                        <p class="has-text-weight-bold is-size-6">Project Client</p>
                      </div>
                      <div class="column is-half">
                        <p class="has-text-right">{{ projectClient }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="box short white">
                    <div class="columns">
                      <div :class="{'is-6' : deviceIsMobile, 'is-5': !deviceIsMobile  }" class="column">
                        <p class="has-text-weight-bold is-size-6">Project Address</p>
                      </div>
                      <div :class="{'is-6' : deviceIsMobile, 'is-7': !deviceIsMobile  }" class="column address-column">
                        <p v-if="projectAddress.line1" class="has-text-left">{{ projectAddress.line1 }}</p>
                        <p v-if="projectAddress.line2" class="has-text-left">{{ projectAddress.line2 }}</p>
                        <p v-if="projectAddress.town" class="has-text-left">{{ projectAddress.town }}</p>
                        <p v-if="projectAddress.postcode" class="has-text-left">{{ projectAddress.postcode }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="box short white">
                    <div class="columns is-mobile">
                      <div class="column is-half">
                        <p class="has-text-weight-bold is-size-6">Client Total (ex VAT)</p>
                      </div>
                      <div class="column is-half">
                        <p class="has-text-right">{{ projectTotal | currencyNotReduced }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="box short white">
                    <div class="columns is-mobile">
                      <div class="column is-half">
                        <p class="has-text-weight-bold is-size-6">Project Status</p>
                      </div>
                      <div class="column is-half">
                        <p class="has-text-right">{{ projectState | title }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="box short white">
                    <div class="columns">
                      <div class="column is-6">
                        <p class="has-text-weight-bold is-size-6">Estimate Status</p>
                      </div>
                      <div class="column is-6">
                        <p class="has-text-right">{{ estimateState | title }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half-desktop is-full-tablet is-full-touch">
          <div :class="{short : !show.reports}" class="box">
            <div class="container__sub-title is-full" @click="toggleMinimise('reports')">
              <h1 class="title has-size-4" style="margin-bottom: 1.5rem">Reports</h1>
              <!--                  <div class="edit">-->
              <!--                    <fa icon="pencil" size="1x" :style="{color: '#fff'}"></fa>-->
              <!--                  </div>-->
              <div v-if="deviceIsMobile" class="minimise">
                <fa :icon="show.reports ? 'chevron-down' : 'chevron-right'" :style="{color: '#fff'}" size="1x"></fa>
              </div>
            </div>
            <div v-if="show.reports && files" class="table-container">
              <file-table
                  :files="{ builderReports: files.builderReports, clientReports: files.clientReports}"/>
            </div>
          </div>
        </div>
        <div class="column is-half-desktop is-full-tablet is-full-touch">
          <div :class="{short : !show.plots}" class="box">
            <div class="columns">
              <div class="column is-12">
                <div class="container__sub-title is-full" @click="toggleMinimise('plots')">
                  <h1 class="title has-size-4">Plots Breakdown</h1>
                  <!--                  <div class="edit">-->
                  <!--                    <fa icon="pencil" size="1x" :style="{color: '#fff'}"></fa>-->
                  <!--                  </div>-->
                  <div v-if="deviceIsMobile" class="minimise">
                    <fa :icon="show.plots ? 'chevron-down' : 'chevron-right'" :style="{color: '#fff'}" size="1x"></fa>
                  </div>
                </div>
                <div v-if="show.plots" class="content scrollable">
                  <div v-for="(plot, index) in plots">
                    <b-collapse
                        :open="plots.length === 1"
                        animation="slide"
                        aria-id="contentIdForA11y3"
                        class="card">
                      <template v-if="plots.length === 1" #trigger="props">
                        <div
                            aria-controls="contentIdForA11y3"
                            class="card-header"
                            role="button"
                        >
                          <p class="card-header-title">
                            <div class="plot-header-title">
                              <p>{{ plot.name | title }}</p>
                            </div>
                            <div class="plot-header-total singleTotal">
                              <p> {{ plot.totals.estimate.total | currencyNotReduced }}</p>
                            </div>
                          </p>
                        </div>
                      </template>
                      <template v-else #trigger="props">
                        <div
                            :aria-expanded="props.open"
                            aria-controls="contentIdForA11y3"
                            class="card-header"
                            role="button">
                          <p class="card-header-title">
                            <div class="plot-header-title-multi">
                              <p>{{ plot.name | title }}</p>
                            </div>
                            <div class="plot-header-total">
                              <p> {{ plot.totals.estimate.total | currencyNotReduced }}</p>
                            </div>
                          </p>
                          <a class="card-header-icon">
                            <b-icon
                                :icon="props.open ? 'chevron-up'  : 'chevron-down' ">
                            </b-icon>
                          </a>
                        </div>
                      </template>
                      <div class="card-content">
                        <div class="content">
                          <div class="plot-sums">
                            <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.material)"
                               class="has-text-weight-bold has-text-left">
                              Material
                            </p>
                            <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.material)"
                               class="has-text-right is-size-6">
                              {{ plot.totals.estimate.material | currencyNotReduced }}
                            </p>
                          </div>
                          <div class="plot-sums">
                            <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.plant)"
                               class="has-text-weight-bold has-text-left">
                              Plant
                            </p>
                            <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.plant)"
                               class="has-text-right is-size-6">
                              {{ plot.totals.estimate.plant | currencyNotReduced }}
                            </p>
                          </div>
                          <div class="plot-sums">
                            <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.labour)"
                               class="has-text-weight-bold has-text-left">
                              Labour
                            </p>
                            <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.labour)"
                               class="has-text-right is-size-6">
                              {{ plot.totals.estimate.labour | currencyNotReduced }}
                            </p>
                          </div>
                          <div class="plot-sums">
                            <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.pcSums)"
                               class="has-text-weight-bold has-text-left">PC
                              Sums
                            </p>
                            <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.pcSums)"
                               class="has-text-right is-size-6">
                              {{ plot.totals.estimate.pcSums | currencyNotReduced }}
                            </p>
                          </div>
                          <div class="plot-sums">
                            <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.professionalFees)"
                               class="has-text-weight-bold has-text-left">
                              Professional Fees
                            </p>
                            <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.professionalFees)"
                               class="has-text-right is-size-6">
                              {{ plot.totals.estimate.professionalFees | currencyNotReduced }}
                            </p>
                          </div>
                          <div class="plot-totals">
                            <div class="plot-sums">
                              <p class="has-text-weight-bold has-text-left">
                                Total
                              </p>
                              <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.total)"
                                 class="has-text-right is-size-6">
                                {{ plot.totals.estimate.total | currencyNotReduced }}
                              </p>
                            </div>
                            <div class="plot-sums">
                              <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.clientTotalExVat)"
                                 class="has-text-weight-bold has-text-left">
                                Client Total
                              </p>
                              <p v-if="hasValidNumberAndAboveZero(plot.totals.estimate.clientTotalExVat)"
                                 class="has-text-right is-size-6">
                                {{ plot.totals.estimate.clientTotalExVat | currencyNotReduced }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <div v-if="plots.length === 0" class="box short white">
                    <p style="text-align: center">No plots available</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half-desktop is-full-tablet is-full-touch">
          <div :class="{short : !show.plans}" class="box">
            <div class="container__sub-title is-full" @click="toggleMinimise('plans')">
              <h1 class="title has-size-4" style="margin-bottom: 1.5rem">Plans</h1>
              <!--                  <div class="edit">-->
              <!--                    <fa icon="pencil" size="1x" :style="{color: '#fff'}"></fa>-->
              <!--                  </div>-->
              <div v-if="deviceIsMobile" class="minimise">
                <fa :icon="show.plans ? 'chevron-down' : 'chevron-right'" :style="{color: '#fff'}" size="1x"></fa>
              </div>
            </div>
            <div v-if="show.plans && files" class="table-container">
              <file-table :files="{plans: files.plans, annotatedPlans: files.annotatedPlans}"></file-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filters from 'module/filters';
import store from 'module/store';
import helpers from "mixin/helpers";

import LoadingIcon from 'component/loading-icon';
import FileTable from "component/file-table";
import ProjectTimeline from 'component/project-timeline';

import {DECLINED, DELETED} from "../../../../../resource/module/constants";

const PENDING = 'PENDING';
const WON = 'WON';
const LOST = 'LOST';
const LIVE = 'LIVE';
const ON_HOLD = 'ON_HOLD';
const COMPLETE = 'COMPLETE';
const ARCHIVED = 'ARCHIVED';
const EXCLUDED = 'EXCLUDED';
const NOT_GOING_AHEAD = 'NOT_GOING_AHEAD';

const READY = 'READY';
const DONE = 'DONE';
const ERROR = 'ERROR';
const LOADING = 'LOADING';

export default {
  name: "project-view",
  beforeRouteEnter(to, from, next) {
    if (store.state.quote.selected.quote) {
      next();
    } else {
      next({name: 'overview'});
    }
  },
  filters,
  components: {
    FileTable,
    LoadingIcon,
    ProjectTimeline
  },
  mixins: [helpers],
  created() {
    this.$store.commit('generic/showSearchBar', false);
    this.$store.dispatch('company/clearFilteredProjects');
  },
  data() {
    return {
      selectedStartDate: null,
      selectedState: {label: 'Pending', value: PENDING, icon: 'clock'},
      state: LOADING,
      errorMessage: null,
      sapAssessmentModal: false,
      tokenType: 'customer',
      labelPosition: 'bottom',
      position: 'left',
      displayMenu: true,
      forceVisible: true,
      stepSize: null,
      showTimeline: false,
      iconColor: '#11458C',
      show: {
        details: false,
        plots: false,
        plans: false,
        reports: false,
      },
      availableStates: [
        {label: 'Pending', value: PENDING, icon: 'clock'},
        {label: 'Won', value: WON, icon: 'check'},
        {label: 'Lost', value: LOST, icon: 'thumbs-down'},
        {label: 'Live', value: LIVE, icon: 'broadcast-tower'},
        {label: 'Completed', value: COMPLETE, icon: 'check-circle'},
        {label: 'Not going ahead', value: NOT_GOING_AHEAD, icon: 'ban'}
      ],
      timelineSteps: [
        {
          label: 'Checking Project Details',
          name: 'checkingProjectDetails',
          isComplete: false,
          included: true,
          internalSteps: ['initialEnquiry', 'quoteAnalysis'],
          text: 'The plans and details are being reviewed. We will be in touch if we need any further information.'
        },
        {
          label: 'Estimator Review',
          name: 'estimatorReview',
          isComplete: false,
          included: true,
          internalSteps: ['estimatorReview'],
          text: 'Your estimator is making sure that he has all the information required for an accurate estimate.'
        },
        {
          label: 'Creating Your Estimate',
          name: 'creatingYourEstimate',
          isComplete: false,
          included: true,
          internalSteps: ['createEstimate'],
          text: 'Your estimator is now constructing your estimate.'
        },
        {
          label: 'Builder Review',
          name: 'builderReview',
          isComplete: false,
          included: true,
          internalSteps: ['builderReview'],
          text: 'Your estimator will be calling you to review your estimate.'
        },
        {
          label: 'Amending Your Estimate',
          name: 'amendingEstimate',
          isComplete: false,
          included: false,
          internalSteps: ['amendQuote', 'amendQuoteFromSap'],
          text: 'Your estimator is now amending your estimate.'
        },
        {
          label: 'Preparing Your Reports',
          name: 'preparingYourReports',
          isComplete: false,
          included: true,
          internalSteps: ['generateReports', 'reGenerateReports', 'confirmReports', 'confirmAmendedReports'],
          text: 'Your reports are now being prepared, Quality Control will check them and we will be contacting you.'
        },
        {
          label: 'Reports Ready',
          name: 'reportsReady',
          isComplete: false,
          included: true,
          internalSteps: [],
          text: 'Your reports are ready. Please review them and confirm that you are happy with them.'
        }
      ]
    }
  },
  computed: {
    deviceIsMobile() {
      return this.$store.state.device.type === 'mobile';
    },
    files() {
      let files = {
        plans: [],
        annotatedPlans: [],
        builderReports: {},
        clientReports: {},
        externalQuotes: {},
      };

      const externalQuotes = _.get(this.project, 'drive.folders.externalQuotes.files', []);
      const builderReportsByPlot = _.get(this.project, 'drive.folders.builder.files', []);
      const clientReportsByPlot = _.get(this.project, 'drive.folders.client.files', []);

      files.plans = _.get(this.project, 'drive.folders.plans.files', []);
      files.annotatedPlans = _.get(this.project, 'drive.folders.annotatedPlans.files', []);


      _.forEach(builderReportsByPlot, (plotFiles) => {
        const plotName = plotFiles.name.split('-')[0]?.trim() || plotFiles.name;

        if (!this.deletedPlots.includes(plotName)) {
          files.builderReports[plotFiles.name] = plotFiles.files ?? [];
        }
      });

      _.forEach(clientReportsByPlot, (plotFiles) => {
        const plotName = plotFiles.name.split('-')[0]?.trim() || plotFiles.name;

        if (!this.deletedPlots.includes(plotName)) {
          files.clientReports[plotFiles.name] = plotFiles.files ?? [];
        }
      });

      _.forEach(externalQuotes, (quote) => {
        files.externalQuotes[quote.name] = quote.files ?? [];
      });

      return files;
    },
    currentStep() {
      return this.timelineSteps.find(step => step.included && step.isComplete === false)?.name ?? 'Reports Ready';
    },
    project() {
      return this.$store.state.quote.selected.quote;
    },
    projectClient() {
      return _.get(this.project, 'form.quoteInfo.customer.name', null);
    },
    projectAddress() {
      let projectAddress = {};
      projectAddress.line1 = _.get(this.project, 'form.quoteInfo.customer.address.line1', null);
      projectAddress.line2 = _.get(this.project, 'form.quoteInfo.customer.address.line2', null);
      projectAddress.town = _.get(this.project, 'form.quoteInfo.customer.address.town', null);
      projectAddress.postcode = _.get(this.project, 'form.quoteInfo.customer.address.postcode', null);

      return projectAddress;
    },
    projectState() {
      return _.get(this.project, 'projectState.state', 'Unknown');
    },
    estimateState() {
      return _.get(this.project, 'computed.currentWorkflow.state.state', 'Self-Estimated');
    },
    projectTotal() {
      return _.get(this.project, 'plots.summary.totals.estimate.clientTotalExVat', 0);
    },
    plots() {
      return _.get(this.project, 'plots.byPlot', []).filter(plot => plot.state.state !== DELETED);
    },
    deletedPlots() {
      return _.get(this.project, 'plots.byPlot', [])
          .reduce((acc, plot) => {
            if (plot.state.state === DELETED) {
              acc.push(plot.name?.trim());
            }
            return acc;
          }, []);
    },
    startDateFormatted() {
      const projectStartDate = _.get(this.project, 'date.projectStart', null);
      const dateToUse = this.selectedStartDate ?? projectStartDate;

      if (dateToUse === null) {
        return 'Unknown';
      }
      return filters.date(dateToUse);
    },
  },
  mounted() {
    this.setTimelineSteps();

    if (!this.deviceIsMobile) {
      this.show = {
        details: true,
        plots: true,
        plans: true,
        reports: true,
      };
    }

    this.selectedState = this.availableStates.find(state => state.value === _.get(this.project, 'projectState.state', null)) ?? this.selectedState;
  },
  watch: {
    deviceIsMobile(newValue) {
      if (!newValue) {
        this.show.details = true;
        this.show.plots = true;
        this.show.reports = true;
        this.show.plans = true;
      } else {
        this.show.details = false;
        this.show.plots = false;
        this.show.reports = false;
        this.show.plans = false;
      }
    },
    startDateFormatted(newValue, oldValue) {
      if (newValue !== oldValue && this.startDateFormatted) {
        this.updateStartDate();
      }
    },
  },
  methods: {
    getStepIcon(step) {
      if (step.isComplete) {
        return 'check';
      } else {
        return '';
      }
    },
    updateProjectState(newState) {
      this.$store.dispatch('quote/projectStatus', {
        quote: this.project,
        state: newState.value,
      })
        .then(() => {
          this.displayMessage('State has been changed successfully', false);
        })
        .catch(() => {
          this.displayMessage('Failed to update state', true);
        });
    },
    updateStartDate() {
      if (this.startDateFormatted === null || this.startDateFormatted === '') {
        return;
      } else {
        this.$store.dispatch('quote/projectStatus', {
          quote: this.project,
          startDate: this.startDateFormatted,
        })
      }
    },
    sapButtonPress() {
      let quote = this.$store.state.quote.selected.quote;
      this.$store.dispatch('quote/requestSapAssessment',
          quote,
      ).then(() => {
        this.loading = false;
        this.edit = false;
      })
    },
    openSapAssessmentModal() {
      this.sapButtonPress()
      this.sapAssessmentModal = true;

    },
    closeSapAssessmentModal() {
      this.sapAssessmentModal = false;
    },
    setTimelineSteps() {
      const workflow = _.get(this.project, 'workflow.quantityTakeOff', null);
      const workflowDeclined = _.get(this.project, 'workflow.quantityTakeOff.state.state', null) === DECLINED;

      if (workflow === null || workflowDeclined) {
        this.showTimeline = false
        return;
      }

      this.showTimeline = true;

      const previousWorkflowSteps = _.get(workflow, 'steps.previous', []);

      _.forEach(previousWorkflowSteps, (step) => {
        const stepName = step.name;
        const stepStatus = step.state;

        _.forEach(this.timelineSteps, (timelineStep) => {
          if (timelineStep.internalSteps.includes(stepName)) {
            timelineStep.isComplete = stepStatus === '5_COMPLETE';

            if (stepName === 'amendQuote' || stepName === 'amendQuoteFromSap') {
              timelineStep.included = true;
            }
          }
        });

        if (_.get(this.project, 'workflow.quantityTakeOff.steps.next', []).length === 0) {
          _.forEach(this.timelineSteps, (timelineStep) => {
            if (timelineStep.name === 'reportsReady') {
              timelineStep.isComplete = true;
            }
          });
        }
      });
    },
    toggleMinimise(section) {
      if (this.deviceIsMobile) {
        this.show[section] = !this.show[section];
      }
    },
    openPCEEditor() {
      if (!this.project.temp.pceProgress) {
        this.$buefy.snackbar.open({
          message: 'This project has not been created using the Primary Cost Estimate tool. Please contact the office.',
          type: 'is-danger',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true,
          queue: false,
        });

        return;
      }

      this.$store.commit('pce/setSelectedJobType', this.project.temp.pceProgress.jobType);
      this.$store.commit('pce/setJobConfig', this.project.temp.pceProgress.jobConfig);

      this.$router.push({
        name: 'primary-cost-estimate',
        params: {pceProgress: _.cloneDeep(this.project.temp.pceProgress)}
      });
    },
    hasValidNumberAndAboveZero(plotTotal) {
      if (typeof plotTotal === 'object') {
        return _.get(plotTotal, '$numberDecimal', 0) > 0;
      }

      return plotTotal > 0;
    },
    setNewState(newState) {
      console.log('state', newState);
      this.updateProjectState(newState);
    }
  }
}
</script>

<style lang="scss" scoped>
.project {
  height: 100%;
  width: 100%;
  background-color: whitesmoke;

  .view-content {
    display: flex;
    align-items: center;
    justify-content: center;

    .columns {
      flex-grow: 1;
    }
  }

  .box {
    height: 100%;
  }

  .timeline-and-buttons {
    display: grid;
    grid-template-columns:  1fr 230px;
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
  }

  .placeholder-status {
    height: 100% !important;
    width: 100% !important;
    display: flex;
    align-content: center !important;
    justify-content: center !important;
  }

  .state-and-date-container {
    margin-left: 10px;
    height: 150px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 5px;
  }

  .start-date-container {
    background-color: $primary;
    display: grid;
    grid-template-columns: 150px 70px;
    grid-template-rows: repeat(2, 1fr);
    height: 72.5px;
    border: 1px solid transparent;
    border-radius: 5px;
  }

  .project-date-label {
    font-weight: bold;
    grid-area: 1 / 1 / 2 / 2;
    padding-left: 1em;
    display: flex;
    align-items: center;
    color: $primary-font-color;
  }

  .date-picked {
    grid-area: 2 / 1 / 3 / 2;
    padding-left: 1em;
    display: flex;
    align-items: center;
    color: $primary-font-color;
  }

  .select-date-button-icon {
    grid-area: 1 / 2 / 3 / 3;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .select-date-button-icon button {
    background-color: transparent;
    border: 1px solid transparent;
    margin-right: 20px;
    padding: 0;
    font-size: 30px;
    color: $primary-font-color;
  }

  .state-selector-container {
    background-color: $accent;
    display: grid;
    height: 72.5px;
    grid-template-columns: 150px 70px;
    grid-template-rows: repeat(2, 1fr);
    border: 1px solid transparent;
    border-radius: 5px;
  }

  .plot-header-title-multi {
    color: $primary-font-color;
    padding-left: 10px;
    padding-top: 25px;
    width: 300px;
  }

  .plot-header-title {
    color: $primary-font-color;
    padding-left: 10px;
    padding-top: 25px;
    width: 300px;
  }

  .card-header-title {
    padding: 0;
  }

  .plot-header-total {
    padding-top: 25px;
    width: 320px;
  }

  .plot-sums {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .plot-sums p {
    margin: 0;
  }

  .plot-totals {
    margin-top: 40px;
  }

  .card-content {
    margin-bottom: 20px;
  }

  .card-header {
    background-color: $secondary;
    color: $primary-font-color;
    height: 70px;
  }

  .card {
    margin-bottom: 20px;
    margin-left: 20px;
  }

  .singleTotal {
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;
  }

  .project-state-label {
    font-weight: bold;
    padding-left: 1em;
    display: flex;
    align-items: center;
    color: $tertiary-font-color;
  }

  .state-icon {
    color: $tertiary-font-color;
    margin-right: 0.5em;
  }

  .b-steps > .steps > .step-items > .step-item > .step-link {
    //color: $primary-font-color;
  }

  .b-steps > .step-content {
    padding: 0 !important;
  }

  .tooltip {
    visibility: hidden;
    background-color: $accent;
    color: $primary-font-color;
    text-align: center;
    border-radius: 4px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .b-step-item:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }

  .content {
    margin-top: 1.5rem;
  }

  .sapAssessment {
    display: flex;
    justify-content: flex-end;
  }

  .sapAssessmentButton {
    background-color: #ffd600;
    color: hsl(0, 0%, 29%);
    margin-top: -20px;
  }

  .sapAssessmentMobile {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;
  }

  .sapAssessmentButtonMobile {
    background-color: #ffd600;
    color: hsl(0, 0%, 29%);
    padding: 1.25rem
  }

  .sapAssessmentModalClass {
    filter: brightness(100%);
    width: 500px;
    height: 220px;
    border: 2px solid #ffd600;
    border-radius: 30px;
    background-color: #11458c;
  }

  .sapAssessmentModalClassMobile {
    filter: brightness(100%);
    width: 300px;
    height: 320px;
    border: 2px solid #ffd600;
    border-radius: 30px;
    background-color: #11458c;
    margin-left: 4rem;
  }

  .sapAssessmentModalHeader {
    text-align: center;
    color: white;
    padding: 20px;
    font-size: 24px;
  }

  .sapAssessmentModalText {
    text-align: center;
    color: white;
    padding: 20px;
  }

  .sapModalButtonDiv {
    text-align: center;
  }

  .sapModalButton {
    background-color: #ffd600;
    color: hsl(0, 0%, 29%);
    margin: 0 auto;
  }

  .current-step-description {
    color: $primary-font-color;
    font-size: 1.25rem;
    font-weight: 500;
    text-align: center;
  }

  .content-section {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;

    .tracker {
      margin: 2em 0 0 0;

      .steps {
        margin-left: 2em;
      }
    }

    .step-content {
      //height: calc(100vh - 120px);
      overflow: auto;
      background-color: $secondary;
    }
  }

  .container__sub-title {
    display: grid;
    justify-content: flex-start;
    align-items: center;
    gap: 2px;
    grid-template-columns: 4fr 1fr;

    .edit {
      &:hover {
        cursor: pointer;
      }
    }

    .minimise {
      align-self: flex-start !important;
      justify-self: flex-end !important;

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>